<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import RdsSubscriptionPage from '@/components/Cloud/Dashboard/pages/rds/subscriptionId-page.vue';
import LambdaSubscriptionPage from '@/components/Cloud/Dashboard/pages/lambda/subscription-page.vue';
import ElasticacheSubscriptionPage from '@/components/Cloud/Dashboard/pages/elasticache/subscription-page.vue';
import IngressSubscriptionPage from '@/components/Cloud/Dashboard/pages/ingress/subscription-page.vue';

const route = useRoute();

const routeToPageMapper = {
  rds: RdsSubscriptionPage,
  lambda: LambdaSubscriptionPage,
  elasticache: ElasticacheSubscriptionPage,
  ingress: IngressSubscriptionPage,
};

const pageToRender = computed(() => {
  const service = route.params.service;

  return routeToPageMapper[service] || null;
});
</script>

<template>
  <component :is="pageToRender" />
</template>
